import { VLandAboutProperty, VLandAboutPropertyBase } from "../common"

export function mapVLandAboutProperty(baseProperty: VLandAboutPropertyBase, hasBuilding: number, buildings: any[]): VLandAboutProperty {
  switch (hasBuilding) {
    case 1: {
      return {
        ...baseProperty,
        hasBuilding: 'Yes',
        buildings,
      }
    }
    case 0: {
      return {
        ...baseProperty,
        hasBuilding: 'No'
      }
    }
    default: {
      return {
        ...baseProperty,
        hasBuilding: 'Idk'
      }
    }
  }
}